import api from '../utils/API';
import { API_URLS } from '../constants/api_urls';
import { v4 as uuidv4 } from 'uuid';

export class AccountService {
  static createClientToAccount = async (accoundId, data) => {
    return await api.post(`${API_URLS.ACCOUNTS_V3}/${accoundId}/user`, data);
  };

  static createAccount = async (data) => {
    return await api.post(API_URLS.ACCOUNTS_V3, data);
  };

  static getAccountsList = async () => {
    return await api.get(API_URLS.ACCOUNTS_V3,
      {params: { limit: -1, offset: 0 }}
    );
  };

  static getAccount = async (data) => {
    const { id } = data;
    return await api.get(
      `${API_URLS.ACCOUNTS_V3}/${id}`,
    );
  };

  static updateAccount = async (payloud) => {
    const { accountId, data } = payloud;
    return await api.put(`${API_URLS.ACCOUNTS_V3}/${accountId}`, data);
  };

  static addRelatedPerson = async (payload) => {
    const {accountId, data} = payload;
    return await api.post(
      `${API_URLS.ACCOUNTS_V3}/${accountId}/user/${data.id}/bind`, data
    );
  };

  static updateRelatedPerson = async (payload) => {
    const {accountId, userId, data} = payload;
    return await api.put(
      `${API_URLS.ACCOUNTS_V3}/${accountId}/user/${userId}`, data
    );
  };

  static getRelatedAccount = async (id) => {
    return await api.get(
      `${API_URLS.ACCOUNTS_V3}/${id}/user`,
    );
  };

  static deleteRelatedPerson = async ({accountId, userId}) => {
    return await api.delete(
      `${API_URLS.ACCOUNTS_V3}/${accountId}/user/${userId}`,
    );
  };

  static setClientType = async (data) => {
    const { id, type } = data;
    return await api.post(`${API_URLS.SET_CLIENT_TYPE}/${id}/type`, {
      ...type,
      client_id: +id,
    });
  };

  static updateClientInfo = async (data) => {
    const { id, client } = data;
    return await api.put(`${API_URLS.UPDATE_CLIENT}/${id}`, client);
  };

  static addClientPhone = async (data) => {
    const { id, phone } = data;
    return await api.post(`${API_URLS.CLIENT}/${id}/phone`, { phone });
  };

  static updateClientPhone = async (data) => {
    const { id, ID, phone } = data;
    return await api.post(`${API_URLS.CLIENT}/${id}/phone`, {
      ID,
      phone,
    });
  };

  static deleteClientPhone = async (data) => {
    const { id, phoneID } = data;
    return await api.delete(`${API_URLS.CLIENT}/${id}/phone/${phoneID}`);
  };

  static getRepresentative = async (clientID) => {
    return await api.get(`/v1/clients/${clientID}/company/representive`);
  };

  static addRepresentative = async (data) => {
    const { id, representative } = data;
    return await api.post(
      `/v1/clients/${id}/company/representive`,
      representative,
    );
  };

  static updateRepresentative = async (data) => {
    const { clientID, id, representative } = data;
    return await api.put(
      `/v1/clients/${clientID}/company/representive/${id}`,
      representative,
    );
  };

  static deleteRepresentative = async (data) => {
    const { id, ID } = data;
    return await api.delete(
      `${API_URLS.CLIENT}/${id}/company/representive/${ID}`,
    );
  };

  static addRepresentativeDoc = async (data) => {
    const { id, representativeId, file, type } = data;
    const sendData = new FormData(file);
    sendData.append('type', type);
    return await api.post(
      `/v1/clients/${id}/company/representive/${representativeId}/documents`,
      sendData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    );
  };

  static setClientMaritalStatus = async (data) => {
    const { id, marital } = data;
    return await api.put(
      `${API_URLS.CLIENT}/${id}/marital-status-and-employment`,
      marital,
    );
  };

  static addClientScore = async (data) => {
    const { id, score } = data;
    return await api.put(`${API_URLS.CLIENT}/${id}/score`, score);
  };

  static setClientAddress = async (data) => {
    const { id, address } = data;
    return await api.put(`${API_URLS.CLIENT}/${id}/address`, address);
  };

  static setClientData = async (data) => {
    const { id, fields } = data;
    return await api.post(`${API_URLS.CLIENT}/${id}/data`, fields);
  };

  static getClientData = async (data) => {
    const { id, name } = data;
    return await api.get(`${API_URLS.CLIENT}/${id}/data/${name}`);
  };

  static sendInvitation = async (data) => {
    const { id, email } = data;
    return await api.post(`${API_URLS.CLIENT}/${id}/invite`, { email });
  };

  static getInvitationInfo = async (data) => {
    const { inviteHash } = data;
    return await api.get(`${API_URLS.INVITE}/${inviteHash}`);
  };

  static acceptInvitation = async (data) => {
    const { inviteHash, password } = data;
    return await api.post(`${API_URLS.INVITE}/${inviteHash}`, { password });
  };

  static setRiskLevel = async (data) => {
    const { id, riskSelected } = data;
    return await api.post(`${API_URLS.CLIENT}/${id}/risk`, {
      risk_level: +riskSelected,
    });
  };

  static sendClientApprove = async (data) => {
    const { id, status } = data;
    return await api.post(`${API_URLS.CLIENT}/${id}/approve`, { status });
  };

  static setClientFees = async (data) => {
    const { id, fees } = data;
    return await api.post(`${API_URLS.CLIENT}/${id}/fees`, fees);
  };

  static getClientFees = async (id) => {
    return await api.get(`${API_URLS.CLIENT}/${id}/fees`);
  };

  static deleteAccount = async (id) => {
    return await api.delete(`${API_URLS.ACCOUNTS_V3}/${id}`);
  };

  static getFinPlan = async (id) => {
    return await api.get(`${API_URLS.CLIENT}/${id}/financialplan`);
  };

  static createFinPlan = async ({ clientId, data }) => {
    return await api.post(
      `${API_URLS.CLIENT}/${clientId}/financialplan`,
      data,
    );
  };

  static patchFinPlan = async ({ clientId, finplanId, body }) => {
    return await api.patch(
      `${API_URLS.CLIENT}/${clientId}/financialplan/${finplanId}`,
      body,
    );
  };

  static deleteFinPlan = async ({ finplanId }) => {
    return await api.delete(
      `${API_URLS.FINPLAN}/${finplanId}`,
    );
  };

  static uploadFinancialItemImage = async (file) => {
    const bodyFormData = new FormData();
    bodyFormData.append('file', file);
    return await api.post(
      `${API_URLS.FINPLANIMAGE}/${uuidv4()}`,
      bodyFormData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    );
  };

  static getSuggestionsPortfolio = async (userId) => {
    return await api.get(
      `${API_URLS.CLIENT}/${userId}/suggestions?offset=0&limit=100`,
    );
  };

  static getApprovedPortfolio = async (userId) => {
    return await api.get(
      `${API_URLS.CLIENT}/${userId}/approved?offset=0&limit=100`,
    );
  };

  static getExecutedPortfolio = async (userId) => {
    return await api.get(
      `${API_URLS.CLIENT}/${userId}/executing?offset=0&limit=100`,
    );
  };

  static getImplementedPortfolio = async (userId) => {
    return await api.get(
      `${API_URLS.CLIENT}/${userId}/implemented?offset=0&limit=100`,
    );
  };

  static getAllApprovedPortfolio = async () => {
    const offset = 0;
    const limit = 100;
    return await api.get(`${API_URLS.ALL_APPROVED}/approved`, {
      params: { limit, offset },
    });
  };

  static getAllExecutedPortfolio = async () => {
    const offset = 0;
    const limit = 100;
    return await api.get(`${API_URLS.ALL_APPROVED}/executing`, {
      params: { limit, offset },
    });
  };

  static getAllImplementedPortfolio = async () => {
    const offset = 0;
    const limit = 100;
    return await api.get(`${API_URLS.ALL_APPROVED}/implemented`, {
      params: { limit, offset },
    });
  };

  static approveSuggestions = async ({ userId, candidatId }) => {
    return await api.post(
      `${API_URLS.CLIENT}/${userId}/candidate/${candidatId}/approve`,
    );
  };

  static deleteSuggestions = async ({ userId, candidatId }) => {
    return await api.delete(
      `${API_URLS.CLIENT}/${userId}/candidate/${candidatId}`,
    );
  };
  /* eslint-disable camelcase */

  static getCandidatTransactions = async ({ portfolio_id, candidatId }) => {
    return await api.get(
      `${API_URLS.PORTFOLIO}/${portfolio_id}/candidate/${candidatId}/transactions`,
    );
  };

  // TODO
  static executeApprovedPortfolio = async ({ portfolioId, candidatId }) => {
    return await api.post(
      `${API_URLS.PORTFOLIO}/${portfolioId}/candidate/${candidatId}/execute`,
    );
  };

  static implementePortfolio = async ({ portfolioId, candidatId }) => {
    return await api.post(
      `${API_URLS.PORTFOLIO}/${portfolioId}/candidate/${candidatId}/executed`,
    );
  };

  static downloadPdfReport = async ({ lang = 'sw', type = 'pdf', timeZone = '', portfolio_id, client_id }) => {
    return await api.get(
      `${API_URLS.PORTFOLIO_V3}/${portfolio_id}/candidate/${client_id}/transactionsreport?type=${type}&lang=${lang}&timezone=${timeZone}`,
      {
        responseType: 'blob',
      },
    );
  };

  static getOnboardingStatus = async ({ clientId }) => {
    return await api.get(
      `${API_URLS.V2_CLIENT}/${clientId}/onboarding/active`,
    );
  };

  static postOnboardingData = async (data) => {
    const { clientId, ...rest } = data;
    return await api.post(
      `${API_URLS.V2_CLIENT}/${clientId}/onboarding`,
      rest,
    );
  };

  static rescheduleOnboarding = async (data) => {
    const { clientId, id, ...rest } = data;
    return await api.put(
      `${API_URLS.V2_CLIENT}/${clientId}/onboarding/${id}`,
      rest,
    );
  };

  static delOnboarding = async (clientId) => {
    return await api.delete(
      `${API_URLS.V2_CLIENT}/${clientId}/onboarding/active`,
    );
  };

  static postOnboardingAudio = async ({ clientId, file }) => {
    return await api.post(
      `${API_URLS.V2_CLIENT}/${clientId}/onboarding/active`,
      file,
    );
  };
  
  static setOnboardingVerifed = async ({ userId, id, data }) => {
    return await api.put(
      `${API_URLS.V2_CLIENT}/${userId}/onboarding/${id}`,
      data,
    );
  };
  
  static uploadOnboardingDocument = async ({ id, docType, files }) => {
    if (!files || files.length === 0) {
      throw new Error('No files provided');
    }
    const filesArray = Array.from(files);
    const bodyFormData = new FormData();
    filesArray.forEach((file, index) => {
      bodyFormData.append(`file${index + 1}`, file);
    });
    return await api.post(`${API_URLS.ONBOARDING}/${id}/document/${docType}`, bodyFormData );
  };
  
  static getOnboardingDocumentsList = async ({ id }) => {
    return await api.get(
      `${API_URLS.ONBOARDING}/${id}/document`);
  };
  
  static deleteOnboardingDocument = async ({ docID }) => {
    return await api.delete(`/v2/document/${docID}`);
  };
    
  static getOnboardingRiskProfile = async ({ userId, id }) => {
    return await api.get(
      `${API_URLS.V2_CLIENT}/${userId}/onboarding/${id}/risk-profile`);
  };
  
  static uploadOnboardingAudio = async ({ id, file }) => {
    if (!file) {
      throw new Error('No files provided');
    }
    const bodyFormData = new FormData();
    bodyFormData.append('file', file);
    return await api.post(`${API_URLS.ONBOARDING}/${id}/audio`, bodyFormData );
  };
  
  static getGooleClientId = async () => {
    return await api.get(API_URLS.OAUTH_CONFIG_V3);
  };
  
  static getGrandFinancialPlan = async (accountId) => {
    return await api.get(`${API_URLS.ACCOUNT_V3}/${accountId}/financial`);
  };
  
  static postGrandFinancialPlan = async ({accountId, data}) => {
    return await api.post(`${API_URLS.ACCOUNT_V3}/${accountId}/financial`, data);
  };
  
  static updateGrandFinancialPlan = async ({data}) => {
    const { id, ...rest } = data;
    return await api.put(`${API_URLS.FINPLAN}/${id}`, rest);
  };
  
  static getFinancialCategory = async () => {
    return await api.get('/v3/financialcategory');
  };
  
  static postFinancialStage = async (data) => {
    const { planId, ...rest } = data;
    return await api.post(`${API_URLS.FINPLAN}/${planId}/stage`, rest?.data);
  };
  
  static updateFinancialStage = async (data) => {
    const { planId, stageId, ...rest } = data;
    return await api.put(`${API_URLS.FINPLAN}/${planId}/stage/${stageId}`, rest?.data);
  };
  
  static deleteFinancialStage = async ({planId, stageId}) => {
    return await api.delete(`${API_URLS.FINPLAN}/${planId}/stage/${stageId}`);
  };
  
  static createFinancialStageItem = async (value) => {
    const { stageId, itemType, data } = value;
    return await api.post(`${API_URLS.FINPLANSTAGE}/${stageId}/${itemType}`, data);
  };
  
  static updateFinancialStageItem = async (value) => {
    const { id, stageId, itemType, data } = value;
    return await api.put(`${API_URLS.FINPLANSTAGE}/${stageId}/${itemType}/${id}`, data);
  };
  
  static deleteFinancialStageItem = async (data) => {
    const { itemId, stageId, itemType } = data;
    return await api.delete(`${API_URLS.FINPLANSTAGE}/${stageId}/${itemType}/${itemId}`);
  };
}
